import { Icon } from "@iconify/react";

export const reactionTypes = [
    {
        type: "like",
        icon: "mdi:thumb-up",
        label: "Like",
        color: "bg-blue-600", // For the icon background
        textColor: "text-blue-600", // For text/borders
        bg: "bg-blue-50",
        hover: "hover:bg-blue-100",
        ring: "ring-blue-300",
    },
    {
        type: "insightful",
        icon: "mdi:lightbulb-on-outline",
        label: "Insightful",
        color: "bg-yellow-600",
        textColor: "text-yellow-600",
        bg: "bg-yellow-50",
        hover: "hover:bg-yellow-100",
        ring: "ring-yellow-300",
    },
    {
        type: "helpful",
        icon: "mdi:sprout",
        label: "Helpful",
        color: "bg-green-600",
        textColor: "text-green-600",
        bg: "bg-green-50",
        hover: "hover:bg-green-100",
        ring: "ring-green-300",
    },
    {
        type: "inspiring",
        icon: "mdi:fire",
        label: "Inspiring",
        color: "bg-orange-600",
        textColor: "text-orange-600",
        bg: "bg-orange-50",
        hover: "hover:bg-orange-100",
        ring: "ring-orange-300",
    },
    {
        type: "respect",
        icon: "mdi:heart",
        label: "Respects the Hustle",
        color: "bg-pink-600",
        textColor: "text-pink-600",
        bg: "bg-pink-50",
        hover: "hover:bg-pink-100",
        ring: "ring-pink-300",
    },
    {
        type: "innovative",
        icon: "mdi:lightbulb",
        label: "Innovative",
        color: "bg-purple-600",
        textColor: "text-purple-600",
        bg: "bg-purple-50",
        hover: "hover:bg-purple-100",
        ring: "ring-purple-300",
    },
    {
        type: "unique",
        icon: "mdi:star-outline",
        label: "Unique Idea",
        color: "bg-indigo-600",
        textColor: "text-indigo-600",
        bg: "bg-indigo-50",
        hover: "hover:bg-indigo-100",
        ring: "ring-indigo-300",
    },
    {
        type: "needs_refinement",
        icon: "mdi:refresh",
        label: "Needs Refinement",
        color: "bg-gray-600",
        textColor: "text-gray-600",
        bg: "bg-gray-50",
        hover: "hover:bg-gray-100",
        ring: "ring-gray-300",
    },
    {
        type: "common",
        icon: "mdi:trending-down",
        label: "Common Idea",
        color: "bg-red-600",
        textColor: "text-red-600",
        bg: "bg-red-50",
        hover: "hover:bg-red-100",
        ring: "ring-red-300",
    },
];
